export default "__VITE_ASSET__Bc1blR6M__"